import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";

interface Column {
  key: string;
  name: string;
  minWidth?: number;
}

interface Props {
  columns: Column[];
  data: any[]; // Assuming data is an array of objects
}

const ReusableTable1: React.FC<Props> = ({ columns, data }) => {
  const [selectedColumns, setSelectedColumns] = useState<Column[]>(columns);

  useEffect(() => {
    setSelectedColumns(columns);
  }, [columns]);

  const handleColumnChange = (event: any) => {
    const selectedKeys = event.target.value as string[];
    const selectedCols = columns.filter((column) =>
      selectedKeys.includes(column.key)
    );
    setSelectedColumns(selectedCols);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, minWidth: 200 }}>
        <Select
          multiple
          size="small"
          value={selectedColumns.map((column) => column.key)}
          onChange={handleColumnChange}
          renderValue={() => {
            return <>Select columns</>;
          }}
        >
          {columns.map((column) => (
            <MenuItem
              key={column.key}
              value={column.key}
              sx={{
                py: 1,
                height: "35px",
                pl: 0.5,
                "& .MuiTypography-root": {
                  fontSize: "14px !important",
                },
                whiteSpace: "normal",
              }}
            >
              <Checkbox
                checked={selectedColumns.some(
                  (selectedColumn) => selectedColumn.key === column.key
                )}
                sx={{ fontSize: "1rem" }}
              />
              <ListItemText primary={column.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TableContainer
        component={Paper}
        sx={{
          // maxHeight: 600,
          "&::-webkit-scrollbar": {
            width: "12px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#fff",
            borderRadius: "8px",
          },
          "&::-webkit-scrollbar-track": {},
        }}
      >
        <Table >
          <TableHead
            sx={{
              "& th": { backgroundColor: "#F0F1F9" },
              tableLayout: "fixed",
              overflowX: "scroll",
            }}
          >
            <TableRow
              sx={{
                "& .MuiTableCell-root": {
                  padding: "10px",
                  borderRightStyle: "solid",
                  borderRightColor: "gray",
                  borderWidth: "1px",
                },
              }}
            >
              {selectedColumns.map((column) => (
                <TableCell key={column.key} style={{ minWidth: column.minWidth }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-around",
                      fontWeight: "600",
                    }}
                  >
                    {column.name} <TuneIcon />
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={selectedColumns.length} sx={{ textAlign: "center" }}>
                  <Typography variant="body2">No data available</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((row, rowIndex) => (
                <TableRow
                  key={rowIndex}
                  sx={{
                    "& .MuiTableCell-root": {
                      padding: "10px",
                      borderRightStyle: "solid",
                      borderRightColor: "gray",
                      borderWidth: "1px",
                    },
                  }}
                >
                  {selectedColumns.map((column) => (
                    <TableCell key={column.key}>{row[column.key]}</TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default ReusableTable1;
